import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_claimant_entity_claim_doc_line_favourite_link_RowClass} from '../../../dbschema';

export class  ClaimClaimantEntityClaimDocLineFavouriteLinkModel extends BaseContainerModel {
    bl_aat_claim_claimant_entity_claim_doc_line_favourite_link: bl_aat_claim_claimant_entity_claim_doc_line_favourite_link_RowClass = new bl_aat_claim_claimant_entity_claim_doc_line_favourite_link_RowClass();
}
